import React, { Component } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import { Grid } from "@material-ui/core";
import Axios from "axios";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EmailIcon from "@material-ui/icons/Email";

import { url } from "../../../../config/config";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import BookItem from "../BookItem/BookItem";
import { useStyles } from "./DisplayList.css";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0a1f3a",
    },
  },
});

class DisplayList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      postPerPage: 8,
      success: "",
      alreadyExist: "",
      notificationOpen: false,
      soldBooks: [],
    };
  }

  componentDidMount() {
    if (this.props.isAuth) {
      this.getSoldBooks(this.props.userToken);
    }
  }

  getSoldBooks = async (userToken) => {
    const response = await Axios.get(`${url}/api/sold/mybooks`, {
      headers: {
        "x-auth-token": userToken,
      },
    });
    if (response.data.length !== 0) {
      response.data.map((data) =>
        data.itemDetails.map((item) =>
          this.setState({
            soldBooks: [...this.state.soldBooks, { bookId: item.bookId }],
          })
        )
      );
    }
  };

  checkExist = (bookId) => {
    return this.state.soldBooks.findIndex((book) => book.bookId === bookId);
  };

  handlePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  handleBook = (bookId) => {
    this.props.history.push(`/books/details/${bookId}`);
  };

  handleCart = async (bookId) => {
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/carts/addToCart`,
        { bookId: bookId },
        {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        }
      );
      if (response.data.bookInCart) {
        this.setState({
          alreadyExist: response.data.bookInCart,
          success: "",
        });
        this.props.getCartCount();
        this.handleNotificationOpen();
      }
      if (response.data.success) {
        this.setState({
          success: response.data.success,
          alreadyExist: "",
        });
        this.props.getCartCount();
        this.handleNotificationOpen();
      }
    } else {
      this.props.history.push("/login/Customer");
    }
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle, message) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="success"
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </SnackBar>
    );
  };

  handleBuyBook = (bookId) => {
    this.props.history.push(`/book/buy/${bookId}`);
  };

  render() {
    const { classes, bookList, authorData } = this.props;
    const { currentPage, postPerPage } = this.state;
    return (
      <div>
        {this.props.authorData && (
          <Grid
            container
            spacing={1}
            style={{
              width: "100%",
              paddingTop: 20,
              paddingLeft: 20,
              display: "flex",
            }}
          >
            <Grid item xs sm={3}>
              <img
                src={authorData.imageUrl}
                alt="AuthorImage"
                style={{ width: 250, height: 250 }}
              />
            </Grid>
            <Grid item xs sm={4}>
              <div style={{ fontSize: 35, fontWeight: "bold" }}>
                {authorData.firstName} {authorData.lastName}
              </div>
              <div
                style={{
                  fontSize: 20,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <EmailIcon />
                {authorData.email}
              </div>
            </Grid>
          </Grid>
        )}
        <div className={classes.root}>
          {bookList.length !== 0 ? (
            <Grid container spacing={3} className={classes.gridContainer}>
              <Grid
                item
                xs
                sm
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: 30,
                  fontWeight: "bold",
                }}
              >
                {this.props.match.params.authorId ? (
                  this.props.match.params.authorId !== "All" ? (
                    <div>
                      Books by Author {authorData.firstName}
                      {authorData.lastName}
                    </div>
                  ) : (
                    <div>All Books</div>
                  )
                ) : (
                  this.props.match.params.genre && (
                    <div>
                      Books for Category {this.props.match.params.genre}
                    </div>
                  )
                )}
              </Grid>
              <Grid
                item
                container
                sm={12}
                spacing={3}
                style={{ width: "100%", display: "flex", flexDirection: "row" }}
              >
                {bookList
                  .slice(
                    (currentPage - 1) * postPerPage,
                    (currentPage - 1) * postPerPage + postPerPage
                  )
                  .map((book, index) => (
                    <BookItem
                      key={index}
                      book={book}
                      handleBook={this.handleBook}
                      handleBuyBook={this.handleBuyBook}
                      handleCart={this.handleCart}
                    />
                  ))}
              </Grid>
              {this.state.success
                ? this.showNotification(
                    classes.notificationStyle,
                    this.state.success
                  )
                : this.showNotification(
                    classes.notificationStyle,
                    this.state.alreadyExist
                  )}
              <div className={classes.paginationStyle}>
                <ThemeProvider theme={theme}>
                  <Pagination
                    count={Math.ceil(bookList.length / postPerPage)}
                    color="primary"
                    page={currentPage}
                    boundaryCount={1}
                    onChange={this.handlePage}
                    showFirstButton
                    showLastButton
                  />
                </ThemeProvider>
              </div>
            </Grid>
          ) : this.props.isEmpty === true ? (
            this.props.match.params.authorId ? (
              this.props.match.params.authorId !== "All" && (
                <CustomEmptyMessage message="No any book has been published yet by this author" />
              )
            ) : (
              this.props.match.params.genre && (
                <CustomEmptyMessage message="No any book for this category has been published yet" />
              )
            )
          ) : (
            <CustomLoader />
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
    isAuth: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(DisplayList)));
